// Hero Media Section JavaScript - Optimized for performance
(function () {
  'use strict';

  function initHeroMedia() {
    // Cache DOM elements
    const heroSection = document.querySelector('.hero-media-section');
    const elements = {
      section: heroSection,
      line1: document.querySelector('.hero-media-line1.hero-media-animate'),
      line2: document.querySelector('.hero-media-line2.hero-media-animate'),
      logo: document.querySelector('.hero-media-logo.hero-media-animate'),
      button: document.querySelector('.hero-media-button.hero-media-animate'),
      trustpilotWidget: document.querySelector('.trustpilot-widget-container'),
      video: document.querySelector('#hero-video'),
      videoMobile: document.querySelector('#hero-video-mobile'),
      muteBtn: document.querySelector('#hero-mute-btn'),
      soundOnIcon: document.querySelector('#sound-on-icon'),
      soundOffIcon: document.querySelector('#sound-off-icon'),
      rotateOverlay: document.querySelector('#hero-rotate-overlay'),
      rotateVideo: document.querySelector('#hero-rotate-video'),
    };

    // Initialize animations
    initAnimations(elements);

    // Initialize rotate overlay if exists
    if (elements.rotateOverlay && elements.rotateVideo) {
      initRotateOverlay(elements);
    }

    // Initialize video controls if videos exist
    if (elements.muteBtn && (elements.video || elements.videoMobile)) {
      initVideoControls(elements);
    }

    // Initialize viewport observer for auto-mute when scrolled out
    if (elements.section && (elements.video || elements.videoMobile)) {
      initViewportObserver(elements);
    }

    // Initialize scroll functionality
    if (elements.section) {
      initScrollFunctionality(elements);
    }
  }

  function initAnimations(elements) {
    // Add animation classes
    ['line1', 'line2', 'logo', 'button'].forEach((key) => {
      if (elements[key]) elements[key].classList.add('hero-media-animate');
    });

    // Handle Trustpilot widget animation
    if (elements.trustpilotWidget) {
      setTimeout(() => checkTrustpilotWidget(elements.trustpilotWidget), 1000);
    }
  }

  function checkTrustpilotWidget(widget) {
    const widgetContent = widget.querySelector('div');
    if (widgetContent && widgetContent.children.length > 0) {
      widget.classList.add('hero-media-animate');
    } else {
      setTimeout(() => checkTrustpilotWidget(widget), 500);
    }
  }

  function initRotateOverlay(elements) {
    const overlay = elements.rotateOverlay;
    const overlayVideo = elements.rotateVideo;
    const section = elements.section;

    if (!overlay || !overlayVideo || !section) return;

    const showOverlaySetting = section.dataset.showRotateOverlay === 'true';
    const hasRotateVideo = section.dataset.hasRotateVideo === 'true';

    if (!showOverlaySetting || !hasRotateVideo) return;

    let isOverlayShown = false;

    function isPortraitOrientation() {
      return window.innerHeight > window.innerWidth;
    }

    function showOverlay() {
      isOverlayShown = true;
      overlay.style.display = 'block';
      requestAnimationFrame(() => {
        overlay.classList.add('show');
      });

      // Pause main videos
      if (elements.video) elements.video.pause();
      if (elements.videoMobile) elements.videoMobile.pause();

      // Reset overlay video to start
      overlayVideo.currentTime = 0;

      // Play overlay video
      overlayVideo.play().catch((err) => {
        console.warn('Overlay video play failed:', err.message);
      });
    }

    function hideOverlay() {
      if (!isOverlayShown) return;

      isOverlayShown = false;
      overlay.classList.remove('show');
      overlayVideo.pause();

      setTimeout(() => {
        overlay.style.display = 'none';

        // Resume main videos after overlay is hidden
        const isPortrait = isPortraitOrientation();
        const activeVideo = isPortrait && elements.videoMobile ? elements.videoMobile : elements.video;

        if (activeVideo) {
          activeVideo.play().catch((err) => {
            console.warn('Main video play failed:', err.message);
          });
        }
      }, 300);
    }

    // Handle overlay video end event
    overlayVideo.addEventListener('ended', () => {
      hideOverlay();
    });

    // Check orientation on load
    function checkOrientation() {
      if (isPortraitOrientation()) {
        showOverlay();
      } else {
        hideOverlay();
      }
    }

    // Initial check
    checkOrientation();

    // Handle orientation changes
    let resizeTimer;
    const handleResize = () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        if (isPortraitOrientation()) {
          showOverlay();
        } else {
          hideOverlay();
        }
      }, 100);
    };

    window.addEventListener('resize', handleResize);
    window.addEventListener('orientationchange', () => {
      setTimeout(() => {
        if (isPortraitOrientation()) {
          showOverlay();
        } else {
          hideOverlay();
        }
      }, 100);
    });
  }

  function initVideoControls(elements) {
    const allVideos = [elements.video, elements.videoMobile].filter(Boolean);
    let hasAudio = false;
    let isInitialized = false;

    // Always start with muted sound
    let isMuted = true;

    function getActiveVideo() {
      const isPortrait = window.innerHeight > window.innerWidth;
      return isPortrait && elements.videoMobile ? elements.videoMobile : elements.video;
    }

    function updateVideoPlayback(forcePlay = false) {
      // Check if rotate overlay is currently showing
      const rotateOverlay = elements.rotateOverlay;
      const isOverlayActive = rotateOverlay && rotateOverlay.classList.contains('show');

      // Don't play main video if overlay is active
      if (isOverlayActive) {
        allVideos.forEach((v) => v.pause());
        return;
      }

      const activeVideo = getActiveVideo();

      allVideos.forEach((v) => {
        if (v === activeVideo) {
          // Only force play on orientation change or manual trigger, not on initial load
          if (forcePlay || isInitialized) {
            playActiveVideo(v);
          } else {
            // On initial load, just set mute state without interrupting autoplay
            v.muted = isMuted;
            updateMuteIcons(v.muted);
          }
        } else {
          v.pause();
        }
      });

      isInitialized = true;
    }

    function playActiveVideo(video) {
      video.volume = 1.0;
      video.muted = isMuted;
      video
        .play()
        .then(() => updateMuteIcons(video.muted))
        .catch((err) => console.warn('Video play failed:', err.message));
    }

    function updateMuteIcons(muted) {
      if (elements.soundOnIcon && elements.soundOffIcon) {
        elements.soundOnIcon.style.display = muted ? 'none' : 'block';
        elements.soundOffIcon.style.display = muted ? 'block' : 'none';
      }
    }

    function checkVideoAudio(video) {
      return !!(
        (video.audioTracks && video.audioTracks.length > 0) ||
        video.mozHasAudio ||
        (video.webkitAudioDecodedByteCount !== undefined && video.webkitAudioDecodedByteCount > 0)
      );
    }

    // Initialize videos
    allVideos.forEach((v) => {
      v.volume = 1.0;

      v.addEventListener('loadedmetadata', () => {
        if (checkVideoAudio(v)) hasAudio = true;
      });

      if (v.readyState >= 3 && checkVideoAudio(v)) {
        hasAudio = true;
      }
    });

    // Check if rotate overlay exists and delay main video playback
    const rotateOverlay = elements.rotateOverlay;
    const showOverlaySetting = elements.section && elements.section.dataset.showRotateOverlay === 'true';
    const hasRotateVideo = elements.section && elements.section.dataset.hasRotateVideo === 'true';
    const isPortrait = window.innerHeight > window.innerWidth;

    if (rotateOverlay && showOverlaySetting && hasRotateVideo && isPortrait) {
      // Delay main video playback until overlay finishes
      allVideos.forEach((v) => {
        v.pause();
      });
    }

    // Show mute button if enabled in admin settings
    const showMuteButton = () => {
      if (elements.muteBtn && elements.section) {
        const showSoundButton = elements.section.dataset.showSoundButton === 'true';

        if (showSoundButton) {
          elements.muteBtn.style.display = 'flex';
          requestAnimationFrame(() => elements.muteBtn.classList.add('show'));
        }
      }
    };

    // Check for audio and set initial state
    setTimeout(() => {
      allVideos.forEach((v) => {
        if (checkVideoAudio(v)) hasAudio = true;
        // Set muted state without interrupting autoplay
        v.muted = isMuted;
      });
      showMuteButton();
      updateMuteIcons(isMuted);
    }, 100);

    // Mute button click handler
    elements.muteBtn.addEventListener('click', (e) => {
      e.preventDefault();
      const activeVideo = getActiveVideo();
      if (activeVideo) {
        activeVideo.muted = !activeVideo.muted;
        isMuted = activeVideo.muted;
        updateMuteIcons(isMuted);
      }
    });

    // Handle orientation changes
    let resizeTimer;
    const handleResize = () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => updateVideoPlayback(true), 250);
    };

    window.addEventListener('resize', handleResize);
    window.addEventListener('orientationchange', () => setTimeout(() => updateVideoPlayback(true), 250));

    // Initial icon state
    updateMuteIcons(isMuted);
  }

  function initViewportObserver(elements) {
    const allVideos = [elements.video, elements.videoMobile].filter(Boolean);
    if (allVideos.length === 0 || !elements.section) return;

    // Check if Intersection Observer is supported
    if (!('IntersectionObserver' in window)) {
      return;
    }

    const observerOptions = {
      root: null, // Use viewport as root
      rootMargin: '0px',
      threshold: 0.1, // Trigger when 10% of section is visible
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) {
          // Section is not visible - mute all videos
          allVideos.forEach((video) => {
            if (video) {
              video.muted = true;
            }
          });
        }
      });
    }, observerOptions);

    observer.observe(elements.section);
  }

  function initScrollFunctionality(elements) {
    const section = elements.section;
    if (!section) return;

    const enableVideoClickScroll = section.dataset.enableVideoClickScroll === 'true';
    const showScrollPrompt = section.dataset.showScrollPrompt === 'true';
    const scrollOffset = Number.parseInt(section.dataset.scrollOffset, 10) || 0;

    // Find next section after hero-media
    function findNextSection() {
      // Try to find the parent container (usually main or shopify-section wrapper)
      let currentElement = section.parentElement;

      // Look for the Shopify section wrapper
      while (currentElement && !currentElement.classList.contains('shopify-section')) {
        currentElement = currentElement.parentElement;
      }

      if (currentElement) {
        // Find next sibling section
        let nextSibling = currentElement.nextElementSibling;
        while (nextSibling) {
          // Check if it's a Shopify section
          if (nextSibling.classList.contains('shopify-section')) {
            return nextSibling;
          }
          nextSibling = nextSibling.nextElementSibling;
        }
      }

      // Fallback: search all sections and find the one after hero-media
      const allSections = document.querySelectorAll('.shopify-section');
      let foundHero = false;
      for (const sectionElement of allSections) {
        if (foundHero) {
          return sectionElement;
        }
        if (sectionElement.querySelector('.hero-media-section')) {
          foundHero = true;
        }
      }

      return null;
    }

    // Smooth scroll to next section
    function smoothScrollToNextSection() {
      const nextSection = findNextSection();
      if (!nextSection) return;

      const targetTop = nextSection.getBoundingClientRect().top + window.pageYOffset - scrollOffset;

      window.scrollTo({ top: targetTop, behavior: 'smooth' });
    }

    // Add click handler to videos and video container if enabled
    if (enableVideoClickScroll) {
      const allVideos = [elements.video, elements.videoMobile].filter(Boolean);
      const videoContainer = section.querySelector('.hero-media-bg');
      const textBlock = section.querySelector('.hero-media-text-block');

      // Add click handler to video container (covers entire video area)
      if (videoContainer) {
        videoContainer.style.cursor = 'pointer';
        videoContainer.addEventListener('click', (e) => {
          e.preventDefault();
          smoothScrollToNextSection();
        });
      }

      // Add click handler to text block (covers text area that overlays video)
      if (textBlock) {
        textBlock.style.cursor = 'pointer';
        textBlock.addEventListener('click', (e) => {
          // Don't trigger scroll if clicking on a link or button inside text block
          const clickedElement = e.target;
          const isLink = clickedElement.tagName === 'A' || clickedElement.closest('a');
          const isButton = clickedElement.tagName === 'BUTTON' || clickedElement.closest('button');

          if (!isLink && !isButton) {
            e.preventDefault();
            smoothScrollToNextSection();
          }
        });
      }

      // Also add to individual videos for better coverage
      allVideos.forEach((video) => {
        if (video) {
          video.style.cursor = 'pointer';
          video.addEventListener('click', (e) => {
            e.preventDefault();
            smoothScrollToNextSection();
          });
        }
      });
    }

    // Add click handler to scroll prompt button
    if (showScrollPrompt) {
      const scrollPrompt = document.querySelector('.hero-scroll-prompt');
      if (scrollPrompt) {
        scrollPrompt.addEventListener('click', (e) => {
          e.preventDefault();
          smoothScrollToNextSection();
        });
      }
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeroMedia);
  } else {
    initHeroMedia();
  }

  window.addEventListener('load', function () {
    const overlay = document.querySelector('#hero-rotate-overlay');
    if (overlay?.classList?.contains('show')) return;

    const videos = [document.querySelector('#hero-video'), document.querySelector('#hero-video-mobile')].filter(Boolean);
    videos.forEach(function (video) {
      if (video.paused) {
        video.play().catch(function () {});
      }
    });
  });
})();
